import { action, observable, reaction, makeObservable } from 'mobx';
import {
  ContentLookup,
  contentLookupService,
  VersionedContentLookup,
  X4Unit,
  X5Lesson
} from '../../../domain';
import {arrayToMap, Disposers, PromiseState} from '../../../lib/helpers';

export class X4UnitLoader {
  @observable.ref
  state: PromiseState<VersionedContentLookup> | null;
  @observable.ref
  lookup: ContentLookup | null;
  @observable.ref
  unit: X4Unit | null;
  @observable.ref
  lessons: readonly X5Lesson[];
  @observable.ref
  lessonById: { [index: number]: X5Lesson };

  private readonly disposers = new Disposers();

  constructor(readonly unitId: number) {
    makeObservable(this);
    this.state = null;
    this.lookup = null;
    this.unit = null;
    this.lessons = [];
    this.lessonById = {};
    this.setup();
  }

  @action
  load = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.load();
  };

  @action
  refresh = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.refresh();
  };

  private setup() {
    this.disposers.add(reaction(
      () => this.state?.value,
      this.onStateChange));
  }

  @action
  private onStateChange = () => {
    this.lookup = null;
    this.unit = null;
    this.lessons = [];
    this.lessonById = {};
    if (this.state?.isResolved !== true)
      return;
    let lookup = this.state.value.lookup;
    let unit = lookup.X4UnitById[this.unitId];
    if (unit === undefined)
      return;
    this.lookup = lookup;
    this.unit = unit;
    this.lessons = unit.Lessons!;
    this.lessonById = arrayToMap(this.lessons, x => x.Id);
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
